import React from 'react';
import { db } from '../firebase';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

function UpdateRole() {
  const { currentUser } = useAuth();

  const updateToDirector = async () => {
    if (currentUser?.email !== 'dan@flair.ac') {
      alert('Not authorized');
      return;
    }

    try {
      // Get the user document
      const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
      
      if (!userDoc.exists()) {
        alert('User document not found');
        return;
      }

      // Update the role
      await updateDoc(doc(db, 'users', currentUser.uid), {
        role: 'director',
        approved: true
      });

      alert('Role successfully updated to Director! Please log out and log back in for changes to take effect.');
    } catch (error) {
      console.error('Error updating role:', error);
      alert('Failed to update role');
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '400px', 
      margin: '40px auto',
      textAlign: 'center' 
    }}>
      <h2>Update Role to Director</h2>
      <button
        onClick={updateToDirector}
        style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '12px 24px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        Update My Role to Director
      </button>
    </div>
  );
}

export default UpdateRole; 